import styled from '@emotion/styled';

const PageContainer = styled.div`
    width: 100vw;
    height: 100vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #f5f5f5;
`;

const Modal = styled.div`
    background: white;
    border-radius: 10px;
    padding: 40px;
    text-align: center;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    width: 500px;
    height: 300px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

const Title = styled.h3`
    font-size: 20px;
    margin-bottom: 50px;
`;

const ButtonContainer = styled.div`
    display: flex;
    justify-content: center;
    gap: 20px;
`;

const Button = styled.button`
    background: ${({ theme }) => theme.colors.secondary.main || '#007bff'};
    color: #fff;
    font-size: 16px;
    font-weight: 700;
    padding: 12px 20px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    width: auto;
    height: auto;
    min-width: 120px;
    min-height: 40px;
    display: flex;
    justify-content: center;
    gap: 20px;

    &:hover {
        background: ${({ theme }) => theme.colors.secondary || '#0056b3'};
    }
`;

interface HipaaStateProps {
    setAccepted: (value: any) => void;
    setCanceled: (value: any) => void;
}

export const HipaaPage = ({ setAccepted, setCanceled }: HipaaStateProps) => {
    const handleContinue = () => {
        setAccepted(true);
    };

    const handleCancel = () => {
        setCanceled(true);
    };

    return (
        <PageContainer>
            <Modal>
                <Title>You are about to possibly access HIPAA protected information</Title>
                <ButtonContainer>
                    <Button onClick={handleContinue}>Continue</Button>
                    <Button onClick={handleCancel}>Cancel</Button>
                </ButtonContainer>
            </Modal>
        </PageContainer>
    );
};

export default HipaaPage;
